/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { TwilioPreview } from 'cio/utils/previews';
import FeaturesService from 'ember-feature-flags/services/features';
import ComposerEditableEntity from 'cio/utils/composer/composer-editable-entity';

interface TwilioContainerArgs {
  editableEntity: ComposerEditableEntity;
  preview: TwilioPreview;
  errors: string[];
  noSenderIdentityError: string;
  isDirty: boolean;
  isPreviewLoading: boolean;
  hasReadOnlyPermission: boolean;
}

enum TwilioChannel {
  SMS = 'sms',
  Whatsapp = 'whatsapp',
}

export default class TwilioContainer extends Component<TwilioContainerArgs> {
  @service features!: FeaturesService;

  readonly TwilioChannel = TwilioChannel;

  get channel() {
    return this.args.editableEntity.template?.whatsapp ? TwilioChannel.Whatsapp : TwilioChannel.SMS;
  }

  @action
  didChangeChannel(channel: TwilioChannel) {
    this.args.editableEntity.template?.set('whatsapp', channel === TwilioChannel.Whatsapp);
  }
}
